import React, { useEffect, useState } from "react";
import "./Invite.css";
import {
  Button,
  Form,
  Image,
  Upload,
  Modal,
  Radio,
  Input,
  message,
  Spin,
  Tag,
} from "antd";
import {
  LocationCityOutlined,
  LocationOn,
  NavigateNextOutlined,
  TitleOutlined,
  TitleTwoTone,
  AssessmentOutlined,
  RepeatOnOutlined,
  ColorLensOutlined,
} from "@mui/icons-material";
import EditableField from "./EditableField";
import "../../App.css";
import moment from "moment";
import { URL } from "../../helper/Mainurl";
import DetailsList from "../DetailsList";
import Reminder from "../CalenderModal/Reminder";
import CollaborationModal from "../CalenderModal/CollaborationModal";
import ColorsModal from "../CalenderModal/ColorsModal";
import RepeatModal from "../CalenderModal/RepeatModal";
import inviteCapture from "../../Assets/InviteCapture/InviteCaptureFinal1.png";
// import processInvite from "../../Assets/InviteCapture/process-invite.png";
import {
  CalendarOutlined,
  ClockCircleOutlined,
  BellOutlined,
  EditOutlined,
} from "@ant-design/icons";

const EditInviteCapture = ({ showModal, closeModal, record }) => {
  const token = localStorage.getItem("authToken");
  const [locationText, setLocationText] = useState(null);
  const [emailTitle, setEmailTitle] = useState(null);
  const [emailDesc, setEmailDesc] = useState(null);
  const [formattedDate, setFormattedDate] = useState("");
  const [noteNew, setNoteNew] = useState("");
  const [processInvite, setProcessInvite] = useState("");
  const [isPdf, setIsPdf] = useState(0);
  const [uploadedImage, setUploadedImage] = useState(null);
  const [formattedTime, setFormattedTime] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [switchTimeStates, setSwitchTimeStates] = useState(false);
  const [descSelectedReminder, setDescSelectedReminder] =
    useState("No reminder");
  const [showRemModal, setShowRemModal] = useState(false);
  const [switchStatesRem, setSwitchStatesRem] = useState(false);
  const [switchStates, setSwitchStates] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [inviteCaptureId, setInviteCaptureId] = useState(null);
  const [isRescanning, setIsRescanning] = useState(0);
  const [isRescanSave, setIsRescanSave] = useState(1);
  const [location, setLocation] = useState("NA");
  const [isUploading, setIsUploading] = useState(false);
  const [showCollaborationModal, setShowCollaborationModal] = useState(false);
  const [showColorModal, setShowColorModal] = useState(false);
  const [showRepeatModal, setShowRepeatModal] = useState(false);
  const [selectedCollaborators, setSelectedCollaborators] = useState([]);
  const [descSelectedColor, setDescSelectedColor] = useState("No color");
  const [colorObj, setColorObj] = useState(null);
  const [selectedColorForPayload, setSelectedColorForPayload] = useState("");
  const [repeatConfig, setRepeatConfig] = useState(null);
  const [isUpdateModalVisible, setIsUpdateModalVisible] = useState(false);
  const [updateType, setUpdateType] = useState("current"); // "current", "upcoming", "all"
  const [switchStatesCollaboration, setSwitchStatesCollaboration] =
    useState(false);
  const [switchStatesColor, setSwitchStatesColor] = useState(false);
  const [switchStatesRepeat, setSwitchStatesRepeat] = useState(false);
  const [descSelectedRepeat, setDescSelectedRepeat] = useState("No repeat");
  const [permission, setPermission] = useState([]);
  const [repeatOption, setRepeatOption] = useState([]);
  const [colorMetaData, setColorMetaData] = useState([]);
  const [adjusWeekend, setAdjustWeekend] = useState([]);
  const [invitees, setInvitees] = useState();
  const [dummyCollaborators, setDummyCollaborators] = useState([]);
  const [loadingMeta, setLoadingMeta] = useState(true);
  const [loadingCollaborators, setLoadingCollaborators] = useState(true);
  const [radioMeta, setRadioMeta] = useState([]);
  const [selectedPriorityIds, setSelectedPriorityIds] = useState(null);
  const [priority, setPriority] = useState([]);
  const [submitLoading, setSubmitLoading] = useState(false);

  const [form] = Form.useForm();
  const [title, setTitle] = useState("");
  const [eventId, setEventId] = useState("");
  const [userId, setUserId] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("pending confirmation");
  const [selectedTime, setSelectedTime] = useState({
    start: null,
    end: null,
  });
  const [uploadedData, setUploadedData] = useState([]); // Store uploaded response

  const [selectedReminder, setSelectedReminder] = useState("No reminder");
  const handleRadioChange = (e) => {
    setSelectedStatus(e.target.value);
  };
  useEffect(() => {
    getCalenderMetaData();
    fetchCollabaroteDate();
  }, []);

  useEffect(() => {
    if (!record) return;

    const startDate = moment(record.start);
    const repeatType = record.repeat_option || "daily";
    const endDate = record.repetition_end_date
      ? moment(record.repetition_end_date)
      : null;
    const endType = endDate ? "custom" : "after";

    let occurrences = 2; // default fallback
    if (endDate && startDate.isBefore(endDate)) {
      switch (repeatType) {
        case "daily":
          occurrences = endDate.diff(startDate, "days") + 1;
          break;
        case "weekly":
          occurrences = endDate.diff(startDate, "weeks") + 1;
          break;
        case "monthly":
          occurrences = endDate.diff(startDate, "months") + 1;
          break;
        default:
          break;
      }
    }

    const excludeWeekends = [];
    if (record.exclude_saturdays === "1") {
      excludeWeekends.push({ id: 2, label: "saturday" });
    }
    if (record.exclude_sundays === "1") {
      excludeWeekends.push({ id: 3, label: "sunday" });
    }

    // Only set repeatConfig and switchStatesRepeat if repeat_option or repetition_end_date is present
    if (record.repeat_option || record.repetition_end_date) {
      const values = {
        repeatType: { value: repeatType },
        endType,
        occurrences,
        customEndDate: endDate ? endDate.format("YYYY-MM-DD") : null,
        excludeWeekends,
        adjustWeekends: record.adjust_weekends || false,
      };
      setRepeatConfig(values);
      setSwitchStatesRepeat(true);
      setDescSelectedRepeat(record.repeat_option);
    } else {
      setRepeatConfig(null);
      setSwitchStatesRepeat(false);
    }

    // // // console.log("eventDatanew::::::", values)
  }, [record]);

  useEffect(() => {
    if (record) {
      setEmailTitle(record.title);
      setEmailDesc(record.description);
      // setGetProgressStatus(email.progress_status_id);
      const eventDate = moment(record.start_date);
      const today = moment();
      const tomorrow = moment().add(1, "day");

      let prefix = "";
      if (eventDate.isSame(today, "day")) {
        prefix = "Today, ";
      } else if (eventDate.isSame(tomorrow, "day")) {
        prefix = "Tomorrow, ";
      }
      if (record?.start_time && record?.end_time) {
        const start = moment.utc(record.start_time).format("HH:mm");
        const end = moment.utc(record.end_time).format("HH:mm");
        setFormattedTime(`${start} - ${end}`);
        setSelectedTime({
          start: start,
          end: end,
        });
        // // // console.log("startEnd", start, end)
        setSwitchTimeStates(true);
      }
      if (record.status) {
        setSelectedStatus(record.status);
      } else {
        setSelectedStatus("pending confirmation");
      }
      if (record?.title) {
        setTitle(record.title);
      }
      if (record?.event_id) {
        setEventId(record.event_id);
      }
      if (record?.user_id) {
        setUserId(record?.user_id);
      }

      if (record?.location) {
        setLocation(record.location);
      }
      if (record.invite_file_path) {
        let is_pdf;
        setProcessInvite(record.invite_file_path);
        if (
          record.invite_file_path &&
          record.invite_file_path.toLowerCase().endsWith(".pdf")
        ) {
          is_pdf = 1;
          setIsPdf(is_pdf);
        } else {
          is_pdf = 0;
          setIsPdf(is_pdf);
        }
      }
      if (record.priority_id) {
        setSelectedPriorityIds(
          record.priority_id ? Number(record.priority_id) : null
        );
      }
      if (record?.reminder_timestamp && record?.start_time) {
        const reminderTime = moment.utc(record.reminder_timestamp); // Convert reminder to UTC
        const eventStartTime = moment.utc(record.start_time); // Convert event start to UTC

        const diffMinutes = eventStartTime.diff(reminderTime, "minutes");
        const diffHours = eventStartTime.diff(reminderTime, "hours");
        const diffDays = eventStartTime.diff(reminderTime, "days");

        let reminderText = "No reminder"; // Default value

        if (diffDays === 0 && diffHours === 0) {
          reminderText = `${diffMinutes} minutes before`;
        } else if (diffDays === 0) {
          reminderText = `${diffHours} hours, ${
            diffMinutes % 60
          } minutes before`;
        } else {
          reminderText = `${diffDays} days, ${diffHours % 24} hours, ${
            diffMinutes % 60
          } minutes before`;
        }

        setDescSelectedReminder(reminderText);
        setSwitchStatesRem(reminderText != "No reminder" ? true : false);
        setSelectedReminder(record.reminder_timestamp);
        // ✅ Enable switch if reminder exists
      } else {
        setDescSelectedReminder("No reminder");
        setSwitchStatesRem(false); // ✅ Disable switch if no reminder
      }
      // When loading record
      if (record.participants && dummyCollaborators.length > 0) {
        const filteredCollaborators = record?.participants
          .map((participant) => {
            // If participant is already a member object, use as is
            // if ( participant.member_id) return participant;
            // If participant has a member object, use that
            // if (participant.member) return { ...participant.member, permission: participant.permission };
            // Fallback: try to find in dummyCollaborators
            const found = dummyCollaborators.find(
              (dc) => String(dc.id) == String(participant.member_id)
            );
            return found
              ? {
                  ...found,
                  permission: participant.permission_id,
                  member_id: participant.member_id,
                }
              : null;
          })
          .filter(Boolean);
        setSelectedCollaborators(filteredCollaborators);
        setSwitchStatesCollaboration(filteredCollaborators.length > 0);
      }
      // if (record?.participants && record?.participants.length && dummyCollaborators.length > 0) {
      //   // Only set collaborators that exist in dummyCollaborators
      //   const filteredCollaborators = record?.participants.filter(participant =>
      //     dummyCollaborators.some(dc => String(dc.id) === String(participant.id))
      //   );
      //   setSelectedCollaborators(filteredCollaborators);
      //   setSwitchStatesCollaboration(filteredCollaborators.length > 0);
      // }
      if (record.color_id && colorMetaData.length > 0) {
        const color = colorMetaData.find((c) => c.id == record.color_id);
        if (color) {
          setColorObj(color);
          setSelectedColorForPayload(color.id);
          setDescSelectedColor(color.label_name);
          setSwitchStatesColor(true);
        } else {
          setSelectedColorForPayload(null);
        }
      }
      // if (record.repeat_option) {
      //   const repeat = repeatOption.find(r => r.value === record.repeat_option);
      //   if(repeat){
      //     setRepeatConfig({ repeatType: repeat });
      //     setDescSelectedRepeat(repeat.label_name);
      //     setSwitchStatesRepeat(true);
      //   }
      // }
      setFormattedDate(`${prefix}${eventDate.format("DD MMMM YYYY")}`);
      setSelectedDate(eventDate.format("DD MMMM YYYY"));
      setSwitchStates(true);
      // const selectedProgressStatus = progressStatus.find(status => status.id == email.progress_status_id) || { id: "", label_name: "Unknown" };
    }
  }, [record, form, repeatOption, colorMetaData]);
  const handleSelectPriority = async (priorityId) => {
    setSelectedPriorityIds(priorityId); // Update UI immediately
  };
  const getCalenderMetaData = async () => {
    setLoadingMeta(true);
    try {
      const response = await fetch(`${URL}/v1/calendar/get-calendar-metadata`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (data.code == 200) {
        setPriority(data.data.priority);
        setRadioMeta(data.data.progress_status);
        setColorMetaData(data.data.colors);
        setPermission(data.data.permissions);
        setRepeatOption(data.data.repeat_option);
        setAdjustWeekend(data.data.adjust_weekends);
      }
    } catch (error) {}
    setLoadingMeta(false);
  };

  const fetchCollabaroteDate = async () => {
    setLoadingCollaborators(true);
    try {
      const response = await fetch(`${URL}/v1/member/get-members-list`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (data.code == 200) {
        if (data.data) {
          const { members, permissions } = data.data;
          const transformedCollaborators = members.map((member) => ({
            id: String(member.id),
            name: member.invitee_nickname,
            email: member.email,
            avatar: member.profile_image,
          }));
          setDummyCollaborators(transformedCollaborators);
          setPermission(permissions);
        }
      }
    } catch (error) {}
    setLoadingCollaborators(false);
  };
  useEffect(() => {
    if (record?.date) {
      setSelectedDate(moment(record.date).format("DD MMMM YYYY")); // Convert to DD-MM-YYYY
    }
    if (record?.location) {
      setLocation(record.location || "");
    }
    if (record?.note) {
      setNoteNew(record.note || "NA");
    }
    if (record?.id) {
      setInviteCaptureId(record.id);
    }
  }, [record]);

  const handleSubmitNew = async (update_type = "all", occurrenceDate) => {
    const getRepetitionEndDate = () => {
      if (!repeatConfig || !formattedStartDate) return null;

      const { endType, occurrences, customEndDate } = repeatConfig;

      if (endType === "custom" && customEndDate) {
        return moment(customEndDate).format("YYYY-MM-DD");
      }

      return moment(formattedStartDate)
        .add(occurrences, "years")
        .format("YYYY-MM-DD");
    };
    const formattedStartDate = moment(selectedDate, "D MMMM YYYY").format(
      "YYYY-MM-DD"
    );
    let formattedDate = moment(
      formattedStartDate,
      ["YYYY-MM-DD", "YYYY/MM/DD", "MM-DD-YYYY", "MM/DD/YYYY"],
      true
    );
    if (!formattedDate.isValid()) {
      formattedDate = moment(
        selectedDate,
        ["YYYY-MM-DD", "YYYY/MM/DD", "MM-DD-YYYY", "MM/DD/YYYY"],
        true
      );
    }

    let formattedStartTime = selectedTime?.start
      ? moment(selectedTime.start, ["HH:mm", "HH:mm:ss"], true).format("HH:mm")
      : "00:00";

    let formattedEndTime = selectedTime?.end
      ? moment(selectedTime.end, ["HH:mm", "HH:mm:ss"], true).format("HH:mm")
      : "23:59";

    const taskStartTime = moment
      .utc(`${formattedDate.format("YYYY-MM-DD")} ${formattedStartTime}`)
      .format("YYYY-MM-DDTHH:mm:ss[Z]");

    const taskEndTime = moment
      .utc(`${formattedDate.format("YYYY-MM-DD")} ${formattedEndTime}`)
      .format("YYYY-MM-DDTHH:mm:ss[Z]");
    const formattedReminder = moment(
      selectedReminder,
      "YYYY-MM-DD HH:mm"
    ).format("YYYY-MM-DDTHH:mm:ss[Z]");
    const transformedCollaborators = selectedCollaborators.map((collab) => ({
      member_id: Number(collab.member_id || collab.id),
      permission_id: String(
        collab.permission?.id || collab.permission_id || collab.permission
      ),
    }));
    const hasSaturday = repeatConfig?.excludeWeekends?.some(
      (w) => w.label === "saturday"
    );
    const hasSunday = repeatConfig?.excludeWeekends?.some(
      (w) => w.label === "sunday"
    );
    let adjustWeekendsValue = null;

    if (repeatConfig?.adjustWeekends) {
      if (hasSaturday && hasSunday) {
        adjustWeekendsValue = "previous_friday";
      } else if (hasSaturday) {
        adjustWeekendsValue = "previous_friday";
      } else if (hasSunday) {
        adjustWeekendsValue = "previous_saturday";
      }
    }

    const eventPayload = {
      title: title,
      location: location || null,
      status: selectedStatus,
      start_date: formattedStartDate,
      start_time: taskStartTime,
      priority_id: selectedPriorityIds,
      end_time: taskEndTime,
      reminder_timestamp: switchStatesRem ? formattedReminder : null,
      invite_capture_id: inviteCaptureId ? Number(inviteCaptureId) : 0, // Convert to number
      is_rescanning: isRescanning ? 1 : 0,
      is_rescan_save: isRescanSave ? 1 : 0,
      note: noteNew || null,
      participants: transformedCollaborators || record.participants,
      repeat_option: repeatConfig?.repeatType?.value || null,
      ...(update_type !== "all" && { occurrence_date: occurrenceDate }),
      update_type: repeatConfig?.repeatType?.value ? update_type : "all",
      color_id:
        selectedColorForPayload === null
          ? null // user explicitly cleared the color
          : selectedColorForPayload?.id || record?.color_id || null,
      exclude_saturdays:
        repeatConfig &&
        repeatConfig.excludeWeekends &&
        repeatConfig.excludeWeekends.length
          ? repeatConfig.excludeWeekends.some((w) => w.label === "saturday")
          : 0,
      exclude_sundays:
        repeatConfig &&
        repeatConfig.excludeWeekends &&
        repeatConfig.excludeWeekends.length
          ? repeatConfig.excludeWeekends.some((w) => w.label === "sunday")
          : 0,
      repetition_end_date:
        update_type == "current"
          ? null
          : repeatConfig?.endType === "custom"
          ? moment(repeatConfig.customEndDate).format("YYYY-MM-DD")
          : getRepetitionEndDate(),
      adjust_weekends: adjustWeekendsValue,
      invitees: invitees,
    };
    // return
    try {
      setSubmitLoading(true);
      const response = await fetch(`${URL}/v1/invite-capture/update`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
        body: JSON.stringify(eventPayload),
      });
      const data = await response.json();

      if (!response.ok) {
        setSubmitLoading(false);
        // Show all backend errors if present
        if (data.errors) {
          Object.values(data.errors)
            .flat()
            .forEach((err) => message.error(err));
        } else if (data.message) {
          message.error(data.message);
        } else {
          message.error(
            `Failed to update invite capture. (${response.status})`
          );
        }
        console.error(
          `HTTP Error: ${response.status} ${response.statusText}`,
          data
        );
        return;
      }

      if (data.code === 200) {
        message.success("Invite capture updated successfully");
        setSubmitLoading(false);
        closeModal(false);
      } else {
        setSubmitLoading(false);
        // Show all backend errors if present
        if (data.errors) {
          Object.values(data.errors)
            .flat()
            .forEach((err) => message.error(err));
        } else if (data.message) {
          message.error(data.message);
        } else {
          message.error("Failed to update invite capture.");
        }
        console.error("API error:", data);
      }
    } catch (error) {
      setSubmitLoading(false);
      console.error("Fetch Error:", error);
      message.error("Network error! Please try again.");

      // Check if it's a CORS issue
      if (error.message.includes("Failed to fetch")) {
        console.error("Possible CORS issue. Check Laravel settings.");
      }
    }
  };
  const handleAddToCalendar = async () => {
    const getRepetitionEndDate = () => {
      if (!repeatConfig || !formattedStartDate) return null;

      const { endType, occurrences, customEndDate } = repeatConfig;

      if (endType === "custom" && customEndDate) {
        return moment(customEndDate).format("YYYY-MM-DD");
      }

      return moment(formattedStartDate)
        .add(occurrences, "years")
        .format("YYYY-MM-DD");
    };
    const formattedStartDate = moment(selectedDate, "D MMMM YYYY").format(
      "YYYY-MM-DD"
    );
    let formattedDate = moment(
      formattedStartDate,
      ["YYYY-MM-DD", "YYYY/MM/DD", "MM-DD-YYYY", "MM/DD/YYYY"],
      true
    );

    if (!formattedDate.isValid()) {
      formattedDate = moment(
        selectedDate,
        ["YYYY-MM-DD", "YYYY/MM/DD", "MM-DD-YYYY", "MM/DD/YYYY"],
        true
      );
    }

    let formattedStartTime = selectedTime?.start
      ? moment(selectedTime.start, ["HH:mm", "HH:mm:ss"], true).format("HH:mm")
      : "00:00";

    let formattedEndTime = selectedTime?.end
      ? moment(selectedTime.end, ["HH:mm", "HH:mm:ss"], true).format("HH:mm")
      : "23:59";

    const taskStartTime = moment
      .utc(`${formattedDate.format("YYYY-MM-DD")} ${formattedStartTime}`)
      .format("YYYY-MM-DDTHH:mm:ss[Z]");

    const taskEndTime = moment
      .utc(`${formattedDate.format("YYYY-MM-DD")} ${formattedEndTime}`)
      .format("YYYY-MM-DDTHH:mm:ss[Z]");

    const formattedReminder = selectedReminder
      ? moment(selectedReminder, "YYYY-MM-DD HH:mm").format(
          "YYYY-MM-DDTHH:mm:ss[Z]"
        )
      : null;
    const transformedCollaborators = selectedCollaborators.map((collab) => ({
      member_id: Number(collab.member_id || collab.id),
      permission_id: String(
        collab.permission?.id || collab.permission_id || collab.permission
      ),
    }));
    // return;
    const hasSaturday = repeatConfig?.excludeWeekends?.some(
      (w) => w.label === "saturday"
    );
    const hasSunday = repeatConfig?.excludeWeekends?.some(
      (w) => w.label === "sunday"
    );
    let adjustWeekendsValue = null;

    if (repeatConfig?.adjustWeekends) {
      if (hasSaturday && hasSunday) {
        adjustWeekendsValue = "previous_friday";
      } else if (hasSaturday) {
        adjustWeekendsValue = "previous_friday";
      } else if (hasSunday) {
        adjustWeekendsValue = "previous_saturday";
      }
    }
    if (title.trim() === "" || !title) {
      message.error("Title is required");
      return;
    }
    if (!selectedDate || selectedDate === "Event date is in the past") {
      message.error("Date is required");
      return;
    }
    if (!selectedTime?.start || !selectedTime?.end) {
      message.error("Start and End time are required");
      return;
    }
    if (location.trim() === "" || !location) {
      message.error("Location is required");
      return;
    }
    if (!selectedPriorityIds) {
      message.error("Priority is required");
      return;
    }
    if (!selectedStatus) {
      message.error("Status is required");
      return;
    }
    const eventPayload = {
      title: title,
      location: location,
      // description: inputTextDesc,
      // display_name_id: selectedDisplayId,
      priority_id: selectedPriorityIds,
      progress_status_id: 26,
      status: selectedStatus,
      start_date: formattedStartDate,
      start_time: taskStartTime,
      end_time: taskEndTime,
      invite_capture_id: inviteCaptureId,
      is_rescanning: 0,
      user_id: userId,
      reminder_timestamp:
        selectedReminder != "No reminder" ? formattedReminder : null,
      participants: transformedCollaborators || record.participants,
      repeat_option: repeatConfig?.repeatType?.value || null,
      repetition_end_date: getRepetitionEndDate(),
      exclude_saturdays:
        repeatConfig &&
        repeatConfig.excludeWeekends &&
        repeatConfig.excludeWeekends.length
          ? repeatConfig.excludeWeekends.some((w) => w.label === "saturday")
          : 0,
      exclude_sundays:
        repeatConfig &&
        repeatConfig.excludeWeekends &&
        repeatConfig.excludeWeekends.length
          ? repeatConfig.excludeWeekends.some((w) => w.label === "sunday")
          : 0,
      adjust_weekends: adjustWeekendsValue,
      color_id:
        selectedColorForPayload === null
          ? null // user explicitly cleared the color
          : selectedColorForPayload?.id || record?.color_id || null,
      invitees: invitees,
      note: noteNew || null,
      // check_list: checkListItems,  // If event-related, include checklist
    };

    // return
    try {
      const response = await fetch(`${URL}/v1/event/create`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
        body: JSON.stringify(eventPayload),
      });

      const data = await response.json();
      if (data.code === 200) {
        message.success("captured event successfully added to calendar");
        // resetFormFields();
        closeModal(false);
        // getData();

        // Clear form fields and state after successful submission
      } else {
        message.error(data.message);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const handleSaveCollaboration = (selected) => {
    // // // console.log("Selected collaborators before state update:", selected);

    // Separate new invitees
    const newInvites = selected.filter((user) => user.newInvitee);
    const confirmedCollaborators = selected.filter((user) => !user.newInvitee);

    // Set only confirmed collaborators
    setSelectedCollaborators(confirmedCollaborators);
    // // // console.log("setSelectedCollaborators", selectedCollaborators)

    setSwitchStatesCollaboration(confirmedCollaborators.length > 0);
    setShowCollaborationModal(false);

    // Add new confirmed collaborators to dummyCollaborators if not already present
    const newCollaborators = confirmedCollaborators.filter(
      (sel) => !dummyCollaborators.some((c) => c.id === sel.id)
    );

    if (newCollaborators.length > 0) {
      setDummyCollaborators((prev) => [...prev, ...newCollaborators]);
    }

    // Extract and set unique invitees
    if (newInvites.length > 0) {
      const invitePayload = newInvites.map((invitee) => ({
        email: invitee.email,
        permission_id: String(invitee.permission.id),
      }));
      setSwitchStatesCollaboration(true);
      setInvitees((prev = []) => {
        const existingEmails = new Set(prev.map((i) => i.email));
        const filteredNew = invitePayload.filter(
          (i) => !existingEmails.has(i.email)
        );
        return [...prev, ...filteredNew];
      });
    }
  };
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };
  const handleTimeChange = (time) => {
    setSelectedTime(time);
  };
  const handleCancel = () => {
    closeModal();
  };
  const beforeUpload = (file) => {
    const isLt2M = file.size / 1024 / 1024 < 2; // Convert bytes to MB

    if (!isLt2M) {
      message.error("File size must be smaller than 2MB!");
      return Upload.LIST_IGNORE; // Prevent upload
    }

    handleImageUpload(file); // Pass file directly
    return false; // Stop default upload behavior
  };

  // Handle image upload & conversion to Base64
  const handleImageUpload = async (file) => {
    if (!file) return;
    setUploadedImage(file); // Store the uploaded image file

    setIsUploading(true); // ✅ Start loader

    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "image/jpg",
      "image/svg+xml",
    ];

    if (!allowedTypes.includes(file.type)) {
      message.warning("Only JPEG, PNG, JPG, and SVG files are allowed!");
      setIsUploading(false); // ✅ Stop loader

      return;
    }

    const reader = new FileReader();

    reader.onload = async () => {
      const base64String = reader.result; // Full Data URL format
      setImageUrl(base64String); // Update image preview

      const payload = {
        invite_file: base64String,
      };

      try {
        const response = await fetch(`${URL}/v1/invite-capture/upload-invite`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
          body: JSON.stringify(payload),
        });

        const data = await response.json();
        if (data.code == 200 && data.data?.captured_data?.length > 0) {
          message.success("Image uploaded successfully!");
          const eventData = data.data.captured_data[0];

          setUploadedData(eventData); // Store API response
          // // // console.log("data.data.captured_data:::::::", eventData)
          const eventDate = moment(eventData.start_date);
          const today = moment();
          const tomorrow = moment().add(1, "day");
          setIsRescanning(1);
          setIsRescanSave(0);
          let prefix = "";
          if (eventDate.isSame(today, "day")) {
            prefix = "Today, ";
          } else if (eventDate.isSame(tomorrow, "day")) {
            prefix = "Tomorrow, ";
          }
          setSelectedDate(eventDate.format("DD MMMM YYYY"));
          if (eventData?.start_time && eventData?.end_time) {
            const start = moment.utc(eventData.start_time).format("HH:mm");
            const end = moment.utc(eventData.end_time).format("HH:mm");
            setSelectedTime({ start, end });
            setFormattedTime(`${start} - ${end}`);
          }
          if (eventData?.title) {
            setTitle(eventData.title); // Correct way to set the title
          }
          if (eventData?.invite_file_path) {
            setProcessInvite(eventData.invite_file_path);
          }
          if (eventData?.location) {
            setLocation(eventData.location);
          }
          // // // console.log("Uploaded Image URL:", data.fileUrl);
        } else {
          message.error("Upload failed!");
        }
      } catch (error) {
        console.error("Upload error:", error);
        message.error("Something went wrong!");
      } finally {
        setIsUploading(false); // ✅ Stop loader
      }
    };

    reader.readAsDataURL(file); // Convert to Base64
  };
  const handlePdfUpload = async (file) => {
    if (!file) return;
    // setUploadedPdf(file); // Store the uploaded PDF file
    setUploadedImage(file);
    setIsUploading(true); // Start loader

    const formData = new FormData();
    formData.append("invite_file", file);

    try {
      const response = await fetch(`${URL}/v1/invite-capture/upload-invite`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });
      const data = await response.json();

      if (data.code === 200 && data.data?.captured_data?.length > 0) {
        message.success("PDF uploaded successfully!");
        let eventData = data.data.captured_data[0];
        eventData.is_pdf = eventData.invite_file_path
          ?.toLowerCase()
          .endsWith(".pdf")
          ? 1
          : 0;

        setUploadedData(eventData);
        setImageUrl(data.fileUrl); // Set the PDF preview URL

        // Update fields if present
        if (eventData.start_date) {
          const eventDate = moment(eventData.start_date);
          setSelectedDate(eventDate.format("DD MMMM YYYY"));
        }
        if (eventData?.start_time && eventData?.end_time) {
          const start = moment.utc(eventData.start_time).format("HH:mm");
          const end = moment.utc(eventData.end_time).format("HH:mm");
          setSelectedTime({ start, end });
          setFormattedTime(`${start} - ${end}`);
        }
        if (eventData?.title) setTitle(eventData.title);
        if (eventData?.location) setLocation(eventData.location);
        if (eventData?.invite_capture_id)
          setInviteCaptureId(eventData.invite_capture_id);
        if (eventData?.invite_file_path) {
          setProcessInvite(eventData.invite_file_path);
        }
        // if (eventData?.user_id) setUserId(eventData.user_id);
      } else {
        message.error("PDF upload failed!");
      }
    } catch (error) {
      console.error("Upload error:", error);
      message.error("Something went wrong!");
    } finally {
      setIsUploading(false);
    }
  };

  const handleSwitchChangeRem = () => {
    const newState = !switchStatesRem;
    if (newState) {
      // Trying to turn ON → open modal first
      setShowRemModal(true);
    } else {
      // Turning OFF → reset reminder
      setDescSelectedReminder("No reminder");
      setSwitchStatesRem(false);
    }
  };

  const handleRemModalClose = () => {
    if (!descSelectedReminder || descSelectedReminder === "No reminder") {
      setSwitchStatesRem(false); // Reset switch if nothing chosen
    }
    setShowRemModal(false);
  };
  const handleSwitchChangeRepeat = () => {
    const newState = !switchStatesRepeat;
    setSwitchStatesRepeat(newState);

    if (newState) {
      // Show modal when turning on
      setShowRepeatModal(true);
    } else {
      // Clear config when turning off
      setRepeatConfig(null);
    }
  };
  const formatDateTimeRem = (selectedDate, selectedTime, selectedReminder) => {
    const validReminderMap = {
      5: "5 minute before",
      30: "30 minute before",
      60: "1 hour before",
      1440: "1 day before",
    };

    const formattedDate = moment(selectedDate, [
      "D MMMM YYYY",
      "DD, MMMM YYYY",
      "YYYY-MM-DD",
      "MM/DD/YYYY",
      "DD MMM YYYY",
    ]);

    if (!formattedDate.isValid()) {
      return { taskStartTime: null, reminderText: "Invalid date" };
    }

    const formattedStartTime = moment(selectedTime?.start, [
      "HH:mm",
      "HH:mm:ss",
    ]);
    if (!formattedStartTime.isValid()) {
      return { taskStartTime: null, reminderText: "Invalid time" };
    }

    const taskStart = moment.utc(
      `${formattedDate.format("YYYY-MM-DD")}T${formattedStartTime.format(
        "HH:mm"
      )}:00Z`
    );

    const taskStartTime = taskStart.format("YYYY-MM-DDTHH:mm:ss[Z]");
    const reminderTime = moment.utc(selectedReminder);

    if (!reminderTime.isBefore(taskStart)) {
      return { taskStartTime, reminderText: "No reminder" };
    }

    const diffMinutes = taskStart.diff(reminderTime, "minutes");

    if (validReminderMap[diffMinutes]) {
      return { taskStartTime, reminderText: validReminderMap[diffMinutes] };
    }

    // Compute human-readable fallback for Customize...
    const totalMinutes = diffMinutes;
    const days = Math.floor(totalMinutes / 1440);
    const hours = Math.floor((totalMinutes % 1440) / 60);
    const minutes = totalMinutes % 60;

    let parts = [];
    if (days > 0) parts.push(`${days} day${days > 1 ? "s" : ""}`);
    if (hours > 0) parts.push(`${hours} hour${hours > 1 ? "s" : ""}`);
    if (minutes > 0) parts.push(`${minutes} minute${minutes > 1 ? "s" : ""}`);

    const customizeLabel =
      parts.length > 0 ? `${parts.join(", ")} before` : "Customize...";

    return { taskStartTime, reminderText: customizeLabel };
  };
  const handleSelectReminder = (reminder) => {
    const { taskStartTime, reminderText } = formatDateTimeRem(
      selectedDate,
      selectedTime,
      reminder
    );
    setSelectedReminder(reminder);
    setDescSelectedReminder(reminderText);
    setSwitchStatesRem(!!reminder);
  };
  const selectTextReminder = (item) => {
    setDescSelectedReminder(item);
  };
  const handleTitleChange = (newTitle) => {
    setTitle(newTitle);
  };
  const handleLocationChange = (newLocation) => {
    setLocation(newLocation);
  };
  const handleReviewAndConfirm = () => {
    if (record.title == "" || record.title == null) {
      message.error("Event title is required");
      return;
    }
    if (record.start_date == "" || record.start_date == null) {
      message.error("Event date is required");
      return;
    }
    if (
      record.start_time == "" ||
      record.start_time == null ||
      record.end_time == "" ||
      record.end_time == null
    ) {
      message.error("Event time is required");
      return;
    }
    if (record.priority_id == "" || record.priority_id == null) {
      message.error("Event priority is required");
      return;
    }
    if (record.status == "" || record.status == null) {
      message.error("Event status is required");
      return;
    }

    if (record?.repeat_option) {
      setIsUpdateModalVisible(true);
    } else {
      handleSubmitNew("all");
    }
  };
  const handleNoteChange = (e) => {
    setNoteNew(e.target.value);
  };
  useEffect(() => {
    if (record?.participants?.length) {
      setSelectedCollaborators(record?.participants);
    }
  }, [record]);
  useEffect(() => {
    setSwitchStatesCollaboration(selectedCollaborators.length);
  }, [selectedCollaborators]);

  return (
    <div>
      <Modal
        maskClosable={false}
        closable={true}
        title={
          <div style={{ textAlign: "left", fontWeight: 600 }}>
            Invite Capture
          </div>
        }
        open={showModal}
        onCancel={closeModal}
        footer={false}
        width={634}
        className="custom-modal"
      >
        {loadingMeta || loadingCollaborators ? (
          <div
            style={{
              minHeight: 400,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Spin size="large" tip="Loading..." />
          </div>
        ) : (
          <div className="modal-content">
            {isUploading ? (
              <h2 className="modal-title-step2 proccessing-title">
                Processing your Invite
              </h2>
            ) : (
              <>
                <div style={{ position: "relative", display: "inline-block" }}>
                  {/* Image Preview */}
                  {isPdf == 1 ? (
                    <>
                      <iframe
                        src={`${processInvite}#toolbar=0&navpanes=0&scrollbar=0`}
                        width="100%"
                        height="300px"
                        // style={{ border: "1px solid #ccc", borderRadius: "8px" }}
                        // title="PDF Preview"
                      />
                      <input
                        type="file"
                        accept="image/png, image/jpeg, image/jpg, image/svg+xml,application/pdf"
                        style={{ display: "none" }}
                        id="fileInput"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (!file) return;
                          if (file.type === "application/pdf") {
                            // handle PDF upload logic (similar to image)
                            handlePdfUpload(file);
                          } else {
                            handleImageUpload(file);
                          }
                        }}
                      />
                      <Button
                        type="primary"
                        shape="square"
                        className="editImageBtn"
                        icon={<EditOutlined />}
                        style={{
                          position: "absolute",
                          top: 0,
                          right: 0,
                          zIndex: 10,
                          background: "#fef1fe",
                          borderColor: "#9a4fe0",
                          color: "#9a4fe0",
                        }}
                        onClick={() =>
                          document.getElementById("fileInput").click()
                        } // Trigger file input
                      />
                    </>
                  ) : (
                    <>
                      <Image
                        width={348}
                        src={processInvite}
                        style={{ borderRadius: 0 }}
                        preview={false}
                      />

                      {/* Hidden File Input for Editing */}
                      <input
                        type="file"
                        accept="image/png, image/jpeg, image/jpg, image/svg+xml"
                        style={{ display: "none" }}
                        id="fileInput"
                        onChange={(e) => handleImageUpload(e.target.files[0])}
                      />
                      <Button
                        type="primary"
                        shape="square"
                        className="editImageBtn"
                        icon={<EditOutlined />}
                        style={{
                          position: "absolute",
                          top: 0,
                          right: 0,
                          zIndex: 10,
                          background: "#fef1fe",
                          borderColor: "#9a4fe0",
                          color: "#9a4fe0",
                        }}
                        onClick={() =>
                          document.getElementById("fileInput").click()
                        } // Trigger file input
                      />
                    </>
                  )}
                </div>

                <div>
                  <div className="invite-container">
                    <EditableField
                      icon={<TitleOutlined />}
                      label="Event Title"
                      value={title}
                      onSave={handleTitleChange}
                      type="text"
                    />
                    <EditableField
                      icon={<CalendarOutlined />}
                      label="Date"
                      value={selectedDate}
                      type="date"
                      onSave={handleDateChange}
                    />
                    <EditableField
                      icon={<ClockCircleOutlined />}
                      label="Time"
                      value={
                        selectedTime.start && selectedTime.end
                          ? `${selectedTime.start} - ${selectedTime.end}`
                          : "Not Set"
                      }
                      type="time"
                      onSave={handleTimeChange}
                      record={record}
                    />
                    <EditableField
                      icon={<LocationOn />}
                      label="Location"
                      value={location || "NA"}
                      onSave={handleLocationChange}
                      type="text"
                    />
                  </div>
                </div>
                <div className="invite-container">
                  <div
                    // style={{
                    //   display: "flex",
                    //   alignItems: "flex-start",
                    //   width: "450px",
                    // }}
                    className="invite-section-heading"
                  >
                    <span>Priority</span>
                  </div>
                  <div
                    // style={{
                    //   display: "flex",
                    //   alignItems: "flex-start",
                    //   width: "450px",
                    //   marginTop: "10px",
                    // }}
                    className="invite-priority-tags"
                  >
                    {priority.length > 0 ? (
                      priority.map((status) => (
                        <Tag
                          onClick={() => handleSelectPriority(status.id)}
                          style={{
                            backgroundColor:
                              selectedPriorityIds === status.id
                                ? "#FEF1FE"
                                : "#ffffff",
                            color:
                              selectedPriorityIds === status.id
                                ? "#9A4FE0"
                                : "#000",
                            border:
                              selectedPriorityIds === status.id
                                ? "1px solid #9A4FE0"
                                : "1px solid #E1E6EF",
                            borderRadius: "10px",
                            cursor: "pointer",
                            fontSize: "14px",
                            padding: "8px 12px",
                            lineHeight: "18px",
                          }}
                          key={status.id}
                        >
                          {status.label_name}
                        </Tag>
                      ))
                    ) : (
                      <p>Loading...</p> // Optional loading state
                    )}
                  </div>
                </div>
                <div
                  className="invite-capture-status"
                  style={{
                    width: "100%",
                    margin: "auto",
                    padding: "15px",
                  }}
                >
                  <div className="invite-section-heading">
                    <p>Status</p>
                  </div>

                  <Radio.Group
                    className="custom-radio-group"
                    onChange={handleRadioChange}
                    defaultValue="pending confirmation"
                    value={selectedStatus}
                  >
                    <Radio
                      value="pending confirmation"
                      className="custom-radio"
                      style={{ width: "250px" }}
                    >
                      Pending Confirmation
                    </Radio>
                    <Radio value="confirmed" className="custom-radio">
                      Confirmed
                    </Radio>
                  </Radio.Group>
                </div>

                <div
                  style={{
                    width: "100%",
                    marginTop: "30px",
                    marginBottom: "30px",
                  }}
                  className="switch-buttons-section"
                >
                  <DetailsList
                    icon={<BellOutlined />}
                    title="Reminder"
                    description={descSelectedReminder}
                    switchChecked={switchStatesRem}
                    onSwitchChange={handleSwitchChangeRem}
                    onClick={() => setShowRemModal(true)}
                  />
                  <DetailsList
                    icon={<AssessmentOutlined />}
                    title="Participants"
                    description={
                      selectedCollaborators.length > 0
                        ? selectedCollaborators
                            .map((c) => {
                              const found = dummyCollaborators.find(
                                (dc) =>
                                  String(dc.id) == String(c?.member_id || c?.id)
                              );
                              return found ? found.name || found.email : null;
                            })
                            .filter(Boolean)
                            .join(", ")
                        : "No participants selected"
                    }
                    switchChecked={switchStatesCollaboration}
                    onSwitchChange={() => setShowCollaborationModal(true)}
                    onClick={() => setShowCollaborationModal(true)}
                  />

                  {/* Repeat */}
                  <DetailsList
                    icon={<RepeatOnOutlined />}
                    title="Repeat"
                    description={descSelectedRepeat}
                    switchChecked={switchStatesRepeat}
                    onSwitchChange={handleSwitchChangeRepeat}
                    onClick={() => setShowRepeatModal(true)}
                  />

                  {/* Color */}
                  <DetailsList
                    icon={<ColorLensOutlined />}
                    title="Color"
                    description={descSelectedColor}
                    switchChecked={switchStatesColor}
                    onSwitchChange={() => setShowColorModal(true)}
                    onClick={() => setShowColorModal(true)}
                  />
                </div>

                <div style={{ width: "-webkit-fill-available" }}>
                  <div
                    // style={{
                    //   display: "flex",
                    //   alignItems: "flex-start",
                    //   width: "450px",
                    // }}
                    className="invite-section-heading notes-label"
                  >
                    <p>Note (Optional)</p>
                  </div>

                  <Input.TextArea
                    placeholder="Enter your notes here..."
                    rows={3} // Adjust the height of the text area
                    allowClear // Adds a clear button inside the input
                    style={{ width: "100%" }} // Ensures it takes full width
                    value={noteNew}
                    onChange={handleNoteChange}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center", // Align buttons to the right
                    alignItems: "center",
                    gap: "12px", // Space between buttons
                    flexWrap: "wrap", // Wrap nicely on small screens
                    marginTop: "20px",
                  }}
                  className="edit-capture-actions"
                >
                  <Button onClick={handleCancel} className="modal-cancel-btn">
                    Cancel
                  </Button>
                  {/* <Button type='primary' className="modal-success-btn" onClick={handleReviewAndConfirm} style={{ marginLeft: '5px' }}>Review & Confirm</Button> */}
                  <Button
                    type="primary"
                    className="modal-success-btn"
                    onClick={handleReviewAndConfirm}
                    // style={{ marginLeft: "5px" }}
                    loading={submitLoading}
                    disabled={submitLoading}
                  >
                    Review & Save
                  </Button>
                  {!eventId && (
                    <Button
                      type="primary"
                      className="modal-success-btn"
                      onClick={handleAddToCalendar}
                      // style={{ marginLeft: "96px" }}
                      loading={submitLoading}
                      disabled={submitLoading}
                    >
                      Add to Calendar
                    </Button>
                  )}
                </div>
              </>
            )}
          </div>
        )}
      </Modal>
      <div>
        {showRemModal && (
          <Reminder
            show={showRemModal}
            handleClose={handleRemModalClose}
            onSelectReminder={handleSelectReminder}
            eventDate={selectedDate}
            eventTime={selectedTime}
            selectReminderTime={selectTextReminder}
          />
        )}

        {showCollaborationModal && (
          <CollaborationModal
            visible={showCollaborationModal}
            onCancel={() => setShowCollaborationModal(false)}
            onSave={handleSaveCollaboration}
            collaborators={dummyCollaborators}
            initialSelected={selectedCollaborators}
            permissionMetadata={permission}
            // tabName={tabName} // <-- Pass the tab name here
          />
        )}

        {showRepeatModal && (
          <RepeatModal
            visible={showRepeatModal}
            onCancel={() => setShowRepeatModal(false)}
            repeatOption={repeatOption}
            adjustWeeknd={adjusWeekend}
            onSave={(repeatData) => {
              setRepeatConfig(repeatData);
              setDescSelectedRepeat(
                repeatData?.repeatType?.label_name
                  ? repeatData.repeatType.label_name
                  : "No repeat"
              );
              setSwitchStatesRepeat(!!repeatData?.repeatType);
              setShowRepeatModal(false);
            }}
            initialValues={repeatConfig}
          />
        )}

        {showColorModal && (
          <ColorsModal
            visible={showColorModal}
            onCancel={() => setShowColorModal(false)}
            metaData={colorMetaData}
            initialSelectedColor={colorObj}
            onSave={(color) => {
              setSelectedColorForPayload(!color ? null : color);
              setDescSelectedColor(color?.label_name);
              setSwitchStatesColor(color?.label_name ? true : false);
              setShowColorModal(false);
            }}
          />
        )}
        <Modal
          open={isUpdateModalVisible}
          onCancel={() => setIsUpdateModalVisible(false)}
          footer={null}
          centered
        >
          <div style={{ padding: 24 }}>
            <h3 style={{ marginBottom: 24 }}>Edit recurring event</h3>
            <Radio.Group
              value={updateType}
              onChange={(e) => setUpdateType(e.target.value)}
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 16,
                marginBottom: 32,
              }}
            >
              <Radio value="current">This event</Radio>
              <Radio value="upcoming">This and upcoming events</Radio>
              <Radio value="all">All events</Radio>
            </Radio.Group>
            <div
              style={{ display: "flex", justifyContent: "flex-end", gap: 12 }}
            >
              <Button onClick={() => setIsUpdateModalVisible(false)}>
                Cancel
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  setIsUpdateModalVisible(false);
                  handleSubmitNew(
                    updateType,
                    moment.utc(record.start).format("D, MMMM YYYY")
                  );
                }}
              >
                OK
              </Button>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default EditInviteCapture;
